import { render, staticRenderFns } from "./CourseOverview.vue?vue&type=template&id=b6c4ea80&scoped=true"
import script from "./CourseOverview.vue?vue&type=script&lang=js"
export * from "./CourseOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c4ea80",
  null
  
)

export default component.exports